import { default as DoubleClickZoom } from 'ol/interaction/DoubleClickZoom';
import { default as RBaseInteraction } from './RBaseInteraction';
/** Zooming by double click */
class RDoubleClickZoom extends RBaseInteraction {
    createOL(props) {
        this.classProps = RDoubleClickZoom.classProps;
        return new DoubleClickZoom(Object.keys(props)
            .filter((p) => this.classProps.includes(p))
            .reduce((ac, p) => (Object.assign(Object.assign({}, ac), { [p]: props[p] })), {}));
    }
}
RDoubleClickZoom.classProps = ['duration', 'delta'];
export default RDoubleClickZoom;
//# sourceMappingURL=RDoubleClickZoom.js.map